import { Controller } from '@hotwired/stimulus';

// data-controller="toc"
export default class extends Controller {
  connect() {
    this.sections = Array.from(document.querySelectorAll('section[id], .accordion-item[id]'));
    this.activeLink = null;

    // Bind methods once (so removeEventListener works correctly)
    this._onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this._onScroll);
    setTimeout(() => {
      this.handleDeepLink();
    }, 200);
  }

  disconnect() {
    window.removeEventListener('scroll', this._onScroll);
  }

  scrollTo(event) {
    event.preventDefault();
    const href = event.currentTarget.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    this.scrollToId(href);
  }

  scrollToId(href) {
    const el = document.querySelector(href);
    if (!el) return;

    // open all parent accordions first — returns true if any were newly opened
    const openedAny = this.openAllParentAccordions(el);

    const scrollAction = () => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        history.replaceState(null, '', href);
      } catch (e) {
        console.warn('History update failed:', e);
      }
    };

    // if any accordion was just opened, wait for its transition (~300 ms)
    if (openedAny) {
      setTimeout(scrollAction, 350);
    } else {
      requestAnimationFrame(scrollAction);
    }
  }

  onScroll() {
    const scrollY = window.scrollY + 120;
    let current = null;

    this.sections.forEach((section) => {
      const top = section.offsetTop;
      const height = section.offsetHeight;
      if (scrollY >= top && scrollY < top + height) current = section.id;
    });

    this.highlight(current);
  }

  highlight(id) {
    if (!id || this.activeLink === id) return;
    this.activeLink = id;

    this.element.querySelectorAll('a').forEach((a) => {
      a.classList.remove('text-primary', 'font-semibold');
      const linkId = a.getAttribute('href')?.replace('#', '');
      if (linkId === id) a.classList.add('text-primary', 'font-semibold');
    });
  }

  handleDeepLink() {
    const hash = window.location.hash;
    if (!hash) return;
    const target = document.querySelector(hash);
    if (!target) return;
    console.log('Deep linking to:', target);
    const accordions = this.getAccordionAndItsAncestors(target);
    console.log('Opening accordions:', accordions);
    accordions.forEach((acc) => {
      const controller = this.getAccordionController(acc);
      console.log('Accordion controller:', controller);
      // If no controller found, skip this accordion
      if (!controller) return;
      console.log('Opening accordion:', acc);
      controller.openValue = true;
      if (typeof controller.open === 'function') controller.open();
    });

    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('ring-2', 'ring-primary', 'rounded-md');
      setTimeout(() => target.classList.remove('ring-2', 'ring-primary', 'rounded-md'), 1500);
    }, 600);
  }

  // === Accordion handling ===

  openAllParentAccordions(el) {
    let opened = false;
    let parent = el.closest("[data-controller~='accordion']");

    while (parent) {
      const controller = this.getAccordionController(parent);
      if (controller) {
        controller.open();
        opened = true;
      }
      parent = parent.parentElement?.closest("[data-controller~='accordion']");
    }

    return opened;
  }

  getAccordionAndItsAncestors(el) {
    const accordions = [];
    let current = el;
    while (current) {
      if (current.matches("[data-controller*='accordion']")) {
        accordions.unshift(current);
      }
      current = current.parentElement;
    }
    return accordions;
  }

  getAccordionController(element) {
    try {
      return this.application.getControllerForElementAndIdentifier(element, 'accordion');
    } catch {
      return null;
    }
  }
}
